import React, { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { List, ListItem } from '@mui/material';
import { Icon } from 'src/mtska-frontend-app-component/assets';

const ComponentSlider = ({ report, maxWidth = '100%', height = 'auto', showTopPagination = false }) => {
    const [activeSection, setActiveSection] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [maxSteps, setMaxSteps] = useState(0);

    const [activeSectionStep, setActiveSectionStep] = useState(0);
    const [maxSectionStep, setMaxSectionStep] = useState(0);

    useEffect(() => {
        setMaxSteps(report.reduce((total, section) => total + section.pages.length, 0));
    }, [report]);

    useEffect(() => {
        setMaxSectionStep(report[activeSection].pages.length);
    }, [activeSection]);

    useEffect(() => {
        let previousPages = 0;
        for (let i = 0; i < activeSection; i++) {
            previousPages += report[i].pages.length;
        }
        setActiveStep(previousPages + activeSectionStep);
    }, [activeSection, activeSectionStep]);

    const handleNext = () => {
        const currentSection = report[activeSection];
        const nextPageIndex = activeSectionStep + 1;

        if (nextPageIndex < currentSection.pages.length) {
            // Resta nella stessa sezione, pagina successiva
            setActiveSectionStep(nextPageIndex);
        } else {
            // Passa alla prossima sezione
            const nextSectionIndex = activeSection + 1;
            if (nextSectionIndex < report.length) {
                setActiveSection(nextSectionIndex);
                setActiveSectionStep(0);
            } else {
                // Torna all'inizio
                setActiveSection(0);
                setActiveSectionStep(0);
            }
        }
    };

    const handleBack = () => {
        if (activeSectionStep > 0) {
            // Pagina precedente nella stessa sezione
            setActiveSectionStep(activeSectionStep - 1);
        } else {
            // Sezione precedente
            const prevSectionIndex = activeSection - 1;
            if (prevSectionIndex >= 0) {
                setActiveSection(prevSectionIndex);
                setActiveSectionStep(report[prevSectionIndex].pages.length - 1);
            } else {
                // Torna alla fine
                const lastSectionIndex = report.length - 1;
                setActiveSection(lastSectionIndex);
                setActiveSectionStep(report[lastSectionIndex].pages.length - 1);
            }
        }
    };

    const goTo = (section, page) => {
        setActiveSection(section);
        setActiveSectionStep(page);
    }

    return (
        <Box className={'mtska-slider'} sx={{ maxWidth: maxWidth, position: 'relative' }}>
            <List className="mtska-slider-page-index">
                {report.map((section, index) => (
                    <React.Fragment key={index}>
                        <ListItem>
                            <Icon icon={section.icon} className="icon"/>
                            {section.title}
                        </ListItem>
                        <List disablePadding>
                            {section.pages.map((page, pageIndex) => (
                                <ListItem key={pageIndex} sx={{ pl: 4 }} onClick={() => goTo(index, pageIndex)} className={"active"+(pageIndex === activeSectionStep && index == activeSection ? " current" : "")}>
                                    <Icon icon={page.icon} className="icon" />
                                    {page.title}
                                </ListItem>
                            ))}
                        </List>
                    </React.Fragment>
                ))}
            </List>

            <Box sx={{ height: height, width: '100%' }} className="mtska-slider-page-wrapper">
                {report[activeSection].pages[activeSectionStep].component}
            </Box>

            <Box className="mtska-slider-pager">
                <IconButton
                    size="small"
                    onClick={handleBack}
                    disabled={maxSectionStep === 0}
                    className='slider-arrow slider-arrow-left'
                >
                    <KeyboardArrowLeft />
                </IconButton>
                <Box className="mtska-page-indicator">
                    {activeStep + 1} / {maxSteps}
                </Box>
                <IconButton
                    size="small"
                    onClick={handleNext}
                    disabled={maxSectionStep === 0}
                    className='slider-arrow slider-arrow-right'
                >
                    <KeyboardArrowRight />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ComponentSlider;